import { formatBatchMarginalia } from '@/learn/kanji/test/[batch]/_lib/format-marginalia'

// Row 1 — `EDITION I · LESSON N · BATCH M–N`. Surface A's frame counter
// register, with the frame slot replaced by a batch range. Same text-meta /
// muted-fg / uppercase / tabular tracking; no vermilion (§7) — position fact,
// not progress accent.
export function MarginaliaTop({
    lessonNumber,
    start,
    end,
}: {
    lessonNumber: number
    start: number
    end: number
}) {
    return (
        <p className="text-meta text-muted-fg uppercase tabular-nums">
            {formatBatchMarginalia(lessonNumber, start, end)}
        </p>
    )
}
